import React, { Component } from 'react';
import { Button, Select,DatePicker,Input } from 'antd';
//import { StatisticsList } from '../../../constants';
import SelectBa from '../../../components/SelectBa';
import moment from 'moment';

const { Option } = Select;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;
class Filter extends Component {
    search = () => {
        this.props.search();
    }

    handleChange = (value, key) => {
        const { searchParams, onChange } = this.props;
        switch (key) {
            case 'customerBaName': {
                const { lastLeaf, checkedKeys, expandedKeys } = value;
                searchParams.lastLeaf = lastLeaf;
                searchParams.checkedKeys = checkedKeys;
                searchParams.expandedKeys = expandedKeys;
                searchParams.customerBaNameIds = (lastLeaf || []).map(i => i.id).join(',');
                searchParams.customerBaNameNames = (lastLeaf || []).map(i => i.title).join(',');
                onChange(searchParams);
                break;
            }
            default:
                searchParams[key] = value;
                onChange(searchParams);
                break;
        }
    }

    render () {
        const { searchParams } = this.props;
        var myDate = new Date();       
        var thisYear = myDate.getFullYear(); 
        var Section = thisYear - 2016; 
        var arrYear = [];
        for(var i = 0;i<=Section;i++){
           arrYear.push(thisYear--)
        }
        const timeList = [];
        (arrYear || []).forEach(item => {
            timeList.push({value:item,label:item});
        });
        const timeOption = timeList.map(i => <Option key={i.value}>{i.label}</Option>);
        const { year,lastLeaf, checkedKeys, expandedKeys }=searchParams;
        return (
            <div style={{ marginBottom: 16 }}>
                <div className="search-bar">
                <div className="search-item">
                        <label htmlFor="" className="ui-label">时间</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 150}}
                            value={year}
                            onChange={value => this.handleChange(value, 'year')}
                        >
                            {timeOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <Button type="primary" onClick={this.search}>统计</Button>
                    </div>
                </div>
                <SelectBa ref={el => this.selectBaRef = el} 
               lastLeaf={lastLeaf}
               checkedKeys={checkedKeys}
               expandedKeys={expandedKeys}
               onChange={args => this.handleChange(args, 'customerBaName')}
                />
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestAndReturnedSheet/AnnualPaymentCollectionAnalysis/HistogramBrokenLine/Filter.js